import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONFIGURATION } from '../app.constants';
import { DealerSourceMapping, NonCDKDealer, ReturnMailer,Subscriber,ClientSubscription } from '../models';
import { throwError } from 'rxjs';
import 'rxjs/add/operator/catch';
import * as _ from 'underscore';


declare var config: any;
@Injectable({ providedIn: 'root' })
export class ErrorlogService {
    constructor(private http: HttpClient) { }
    private AdmtServiceUrl = CONFIGURATION.baseUrls.ADMTServiceURL;
    
   
    getErrorLogDetails(daterangefilter,startDate,endDate): Observable<any> {
        const url = this.AdmtServiceUrl + 'error-log/geterrorlogs?daterangefilter='+daterangefilter+'&startDate='+startDate+'&endDate='+endDate;
        return this.http.get(url);
    }
    updateErrorLogDetails(log_id,comments,status,updated_by): Observable<any> {
        const url = this.AdmtServiceUrl + 'error-log/updateerrorlogstatus?error_log_id=' + log_id+'&comments='+comments+'&status='+status+'&updated_by='+updated_by;
        return this.http.get(url);
    }
   
    ///------------Response JSON------------------
    private extractData(response: Response) {

        let body = response.json();
        return body;
    }
    handleServerError(error: any | any) {
        console.log(error.error || error.json() || error);
        return throwError(error.error || error.json() || error || 'Server error');
    }
}